// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1MEmr","paymentContainer":"PaymentPage_paymentContainer__2TFTQ"};